import { useIntl } from 'react-intl';
import { messages } from './order-detail.messages';
import { OrderDetailProps } from './types';

export const OrderDetails = ({ purchaseType }: OrderDetailProps) => {
  const { formatMessage } = useIntl();

  const messageID =
    purchaseType === 'program'
      ? 'payment.order.details.section.mode.program'
      : purchaseType === 'professional'
        ? 'payment.order.details.section.mode.professional'
        : purchaseType === 'credit'
          ? 'payment.order.details.section.mode.credit'
          : 'payment.order.details.section.mode.verified';

  return (
    <div>
      <h2 className="h5">
        {formatMessage(messages['payment.order.details.section.heading'])}
      </h2>
      <p>{formatMessage(messages[messageID])}</p>
    </div>
  );
};
